import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomIcon } from 'shared/components/icon/custom';
import { useHelpPopup } from 'shared/hooks/ui';
import { LightTooltip } from 'shared/components/icon/icon.user_icons_panel/style';
import { ColorSvgIcon } from 'shared/components/icon/style-for-custom';
export const IconPanelSettingsAccount = memo(function IconPanel(props) {
    const { array, filterArrayNotSimilar } = props;
    const [HelpPopup, open] = useHelpPopup();
    const [indexIcon, setIndexIcon] = useState();
    const openTouchTooltip = useCallback((id, event) => {
        open(event);
        setIndexIcon(id);
    }, []);
    const touchTooltip = array.find((Icon) => Icon.id === indexIcon);
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            color: 'inherit',
        }, children: [filterArrayNotSimilar?.map((Icon) => {
                return (_jsx(Box, { padding: "5px", children: _jsx(LightTooltip, { title: _jsxs(Box, { display: 'flex', flexDirection: 'column', children: [_jsx(CustomIcon, { Icon: Icon.render, fontSize: "10em" }), _jsx(Typography, { textAlign: 'center', children: Icon.title })] }), children: _jsx(ColorSvgIcon, { children: _jsx(CustomIcon, { Icon: Icon.render, fontSize: "4em", onTouchStart: (event) => openTouchTooltip(Icon.id, event) }) }) }) }, Icon.id));
            }), _jsx(HelpPopup, { children: touchTooltip?.render != null && (_jsx(CustomIcon, { Icon: touchTooltip.render, fontSize: "10em" })) })] }));
});
